<template>
  <div class="agreement">
    <div class="title">隐私协议</div>
    <p
      class="ps"
    >JoyOrders 平台（www.joyorders.com）隐私权保护声明系 JoyOrders 网保护用户个人隐私的承诺。鉴于网络的特性， JoyOrders 网将不可避免地与您产生直接或间接的互动关系，故特此说明 JoyOrders 网对用户个人信息所采取的收集、使用和保护政策，请您务必仔细阅读：</p>
    <p></p>
    <p class="t4">一、使用者非个人化信息</p>
    <p></p>
    <p
      class="ps"
    >我们将通过您的 IP 地址来收集非个人化的信息，例如您的浏览器性质、操作系统种类、服务的 ISP 的域名等，以优化在您计算机屏幕上显示的页面。通过收集上述信息，我们亦进行客流量统计，从而改进网站的管理和服务。</p>
    <p></p>
    <p class="t4">二、个人资料</p>
    <p></p>
    <p
      class="ps"
    >1、 当您在 JoyOrders 网进行用户注册、登记、网上购物、参加网上拍卖或公共论坛等活动时，在您的同意及确认下， JoyOrders 网将通过注册表格、订单等形式要求您提供一些个人资料。这些个人资料包括：个人识别资料：如姓名、性别、年龄、出生日期、身份证号码（或护照号码）、电话、通信地址、住址、电子邮件地址等情况。</p>
    <p class="ps">2、 在未经您同意及确认之前， JoyOrders 网不会将您为参加本网站之特定活动所提供的资料利用于其它目的。</p>
    <p></p>
    <p class="t4">三、信息安全</p>
    <p></p>
    <p
      class="ps"
    >JoyOrders 网将对您所提供的资料进行严格的管理及保护，我们将采取适当的步骤，防止您的个人资料丢失、被盗用或遭窜改。每当您提供给我们敏感信息时，我们将采取合理的步骤保护您的敏感信息，我们也将采取合理的安全手段保护已存储的个人信息。除非根据法律或政府的强制性规定，在未得到您的许可之前，我们不会把您的任何个人信息提供给无关的第三方(包括公司或个人)。但是，如果您要求我们提供特定客户支援服务或把一些物品送交给您，我们则需要把您的姓名和地址提供给第三者如运输公司。我们的网站将会提供第三者网站的链接。由于我们不能控制这些网站，所以我们建议您细阅这些第三者网站的个人信息保密制度。</p>
    <p></p>
    <p class="t4">四、隐私权原则</p>
    <p></p>
    <p
      class="ps"
    >1、 每当 JoyOrders 网需要识别您的身份或与您联络时，会明确的询问所需的资料，即个人资料。一般而言，当您在网站上注册，要求提供特别服务，或是如余额提现，便会被询问到这项资料。 JoyOrders 网会利用一些有效方法，确认您的个人资料的正确性与有效性。</p>
    <p></p>
    <p
      class="ps"
    >2、 当政府机关依照法定程序要求 JoyOrders 网披露个人资料时， JoyOrders 网将根据执法单位之要求或为公共安全之目的提供个人资料。在此情况下之任何披露， JoyOrders 网均得免责。</p>
    <p></p>
    <p class="ps">3、 任何时候如果您认为 JoyOrders 网没有遵守这些原则时，请及时与我们联系，我们会尽一切努力，在合理适当的范围内立即完善这个问题。</p>
    <p></p>
    <p class="t4">五、公共论坛</p>
    <p></p>
    <p class="ps">JoyOrders 网为您提供交易论坛等服务。在这些区域内，您公布的任何信息都会成为公开的信息。因此，我们提醒并请您慎重考虑是否有必要在这些区域公开您的个人信息。</p>
    <p></p>
    <p class="t4">六、Cookies</p>
    <p></p>
    <p
      class="ps"
    >Cookies 是指一种技术，当使用者访问设有 Cookies 装置的本网站时， JoyOrders 网之服务器会自动发送 Cookies 至阁下浏览器内，并储存到您的电脑硬盘内，此 Cookies 便负责记录日后您到访 JoyOrders 网的种种活动、个人资料、浏览习惯、消费习惯甚至信用记录。使用cookies主要是以便我们知道哪些网站受欢迎，使您在访问我们的网站时得到更好的服务，并且请您放心cookies不会跟踪个人信息。</p>
    <p></p>
    <p class="t4">七、Affiliate Cookies</p>
    <p></p>
    <p class="ps">当用户点击本网站的链接跳转到其他商家时， JoyOrders 网之服务器会自动发送 Cookies 至阁下浏览器内，并储存到您的电脑硬盘内。
  If the end user chooses to click on the drop down offer they will be redirected to the partner's (aka advertiser's) site via affiliate cookies.
  You can block/remove partner's cookies by <a href="http://optout.aboutads.info">http://optout.aboutads.info (DAA).</a>
    </p>
    <p></p>
    <p class="t4">八、关于订阅邮件</p>
    <p></p>
    <p class="ps">我们将根据您的注册邮箱，为您发送网站的相关资讯和产品信息，如果您不想继续订阅，可以点击邮件内容上方的退订按钮实现。</p>
    <p></p>
    <p class="t4">九、免责</p>
    <p></p>
    <p class="ps">发生下列情况时 JoyOrders 网无需承担任何责任：</p>
    <p></p>
    <p class="ps">1、 由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露。</p>
    <p></p>
    <p class="ps">2、任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人资料泄露、丢失、被盗用或被窜改等。</p>
    <p></p>
    <p class="ps">3、 由于与 JoyOrders 网链接的其它网站所造成之个人资料泄露及由此而导致的任何法律争议和后果。本网站之保护隐私声明的修改及更新权均属于 JoyOrders 网(<a href="www.joyorders.com">www.joyorders.com</a>）
    </p>
  </div>
</template>

<script>
export default {
  name: 'private-aggrement'
}
</script>

<style scoped lang="less">
.agreement {
  white-space: pre-wrap;
  max-width: 1160px;
  margin: 30px auto;
  font-size: 16px;
  .title{
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin: 20px auto;
  }
  a{
    font-size: 16px;
  }
  p {
    font-size: 16px;
    line-height: 24px;
  }
  .ps {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .em {
    font-weight: 700;
  }
  .t4 {
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/treaty/PrivateAgreement.vue